import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { MomentTimezonePipeModule } from "../../../../shared/module/pipe/moment-timezone-pipe.module";
import { VenuePipeModule } from "../../../venue-pipe.module";
import { BookingDetailsComponent } from "./booking-details.component";

import { DiscountModule } from "../../pay/partials/discount/discount.module";

import { IconSharedModule } from "pf_styleguide";

@NgModule({
    declarations: [BookingDetailsComponent],
    imports: [
        CommonModule,
        MomentTimezonePipeModule,
        IconSharedModule,
        VenuePipeModule,
        DiscountModule,
    ],
    exports: [BookingDetailsComponent],
    providers: [],
})
export class BookingDetailsModule {}
